import ButtonLink from '@components/button-link/ButtonLink';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, { CSSProperties } from 'react';

import useStyles from './JobCard.style';

interface JobCardProps {
  jobTitle?: string;
  location?: string;
  preferredSkills?: string[];
  applyLink?: string;
  style?: CSSProperties;
  className?: string;
  children?: React.ReactNode;
}

const JobCard: React.FC<JobCardProps> = (props) => {
  const { jobTitle, location, applyLink, preferredSkills, children } = props;
  const { classes, theme } = useStyles();

  return (
    <Box className={classes.JobCardContainer}>
      <Grid container>
        <Grid item>
          <Typography
            component="h1"
            variant="h4Alt"
            style={{ color: '#161332' }}
          >
            {jobTitle}
          </Typography>

          <Typography
            style={{ fontSize: 14, fontFamily: theme.gh_vars.circular }}
            color="textSecondary"
          >
            {location}
          </Typography>
        </Grid>

        <Grid
          item
          style={{ margin: 'auto' }}
        >
        </Grid>

        <Grid item >
          <Button
            size="small"
            variant="contained"
            color="secondary"
            className={classes.applyButton}
            href={applyLink}
            target="_blank"
            component={ButtonLink}
          >
            Apply
          </Button>
        </Grid>

      </Grid>

      <Divider style={{ color: '#ebf0f6', margin: theme.spacing(2, 0) }} />

      {children}

      {!!preferredSkills?.length && (
        <>
          <Typography
            component="h3"
            variant="h5Alt"
            className={classes.jobDescriptionHeader}
            style={{ marginTop: theme.spacing(3) }
            }
          >
            Preferred Skills
          </Typography>
          <Box
            flexDirection="row"
            flexWrap="wrap"
            style={{ marginTop: theme.spacing(1) }}
          >
            {preferredSkills.map((skill, i) => (
              <Chip
                key={i}
                label={skill}
                style={{ margin: theme.spacing(0, 1, 1, 0) }}
              />
            ))}
          </Box>
        </>
      )}


    </Box>
  );
};

JobCard.defaultProps = {
  style: {},
  className: null,
};

export default JobCard;
